import React, { useEffect, useMemo, useState } from 'react';
import ReactPlayer from 'react-player';

import { styled } from 'styled-components';

const EMPTY_ASSETS = [];

function AssetArea({item}) {
  const [count, setcount] = useState(4);
  const data = item?.project_asset || EMPTY_ASSETS;

  useEffect(() => {
    setcount(4);
  }, [item?.id, item?.slug]);

  const assets = useMemo(() => {
    const pattern = [40, 40, 40, 40, 40, 40, 40, 40, 40];
    const mobilePattern = [60, 39, 39, 60];

    return data.slice(0, count).map((asset, index) => ({
      ...asset,
      width: data.length === 1 ? 90 : pattern[index % pattern.length],
      smWidth: data.length === 1 ? 90 : mobilePattern[index % mobilePattern.length],
    }));
  }, [data, count]);

  const canLoadMore = count < data.length;
  
  const handleLoadMore = () => {
    setcount((currentCount) => Math.min(currentCount + 4, data.length));
  };

  return (
    <Section>
      <ProjectListArea>
        {assets.map((obj, index) => (
          <SingleProject
            key={obj.id || obj.project_image || obj.computer_video || index}
            w={obj.width}
            sm={obj.smWidth}
          >
            <Container>
              {obj?.asset_type === "image" ? (
                <img loading="lazy" src={obj?.project_image} alt="" />
              ) : (
                <ReactPlayer
                  width="100%"
                  height="100%"
                  url={obj?.computer_video}
                  playing
                  playsinline
                  muted
                  controls
                  loop
                />
              )}
            </Container>
          </SingleProject>
        ))}
      </ProjectListArea>
      {canLoadMore && (
        <LoadButton>
          <button type="button" onClick={handleLoadMore}>
            Load More
          </button>
        </LoadButton>
      )}
     
    </Section>
  )
}

export default AssetArea;



const Section = styled.div`
  width:100%;
  @media(max-width:580px){
    width:100%;
  }
`;

const ProjectListArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap:15px 8px;
  /* grid-template-columns: 40% 60%; */
  /* row-gap: 15px; */
  margin:20px 0;
  justify-content:center;
  align-items:center;

  @media(max-width:580px){
  row-gap: 5px;
  }
`;

const LoadButton = styled.div`
width: 100%;
margin: 0px 0px 25px;
display: flex;
justify-content: center;
align-items:center;
position: relative;
z-index: 1;

@media(max-width:1400px){
    margin: 40px 0px 25px;
    
}

button{
    border:1px solid var(--primary-cl);
    background-color: white;
    padding: 12px  26px;
    font-size:14px;
    font-family: 'raleway_medium';
    color: #000;

    &:hover{
        background-color: var(--primary-cl);
        color: #fff;
    }
}
`;

const SingleProject = styled.div`
${(props)=>props.w && `width:${props.w}%;`}

@media(max-width: 1024px){
  ${(props)=>props.sm && `width:${props.sm}%;`}
}

@media(max-width: 900px){
  width: 49%;
}
@media(max-width:580px){
    width:100%;
    position: relative;
    /* &::after{
      content:'';
      position: absolute;
      inset: 0;
      background-color:#000;
      opacity: .3;
    } */
}

@media(max-width:480px){
  width: 100%;
}

`;

const Container = styled.div`
width: 100%;
position: relative;
img{
    width: 100%;
    height: auto;
    display: block;
}
video{
    width: 100%;
    aspect-ratio: 16/9;
    display: block;
    object-fit: cover;
}
`;








































































































// const Section = styled.div`
//   padding-left: 30px;
//   /* height: 650px; */
//   height: auto;
//   margin: 50px 0px 75px;

//   @media(min-width:2000px){
//     /* height: 750px; */
//   }
//   @media(max-width:1440px){
//     /* height: 550px; */
//   }
//   @media(max-width:968px){
//     padding-left: 20px;
//   }
//   @media(max-width:580px){
//     padding-left: 10px;
//     /* height: 375px; */
//   }

//   @media(max-width:450px){
//     /* height: 325px; */
//     padding-left: 0px;
//   }
//   @media(max-width:375px){
//     /* height: 250px; */
//   }
// `;
  //return (
  //   <>
  //   <Section>
  //     {/* <AssetSlider assets={item?.assets}/> */}
  //   </Section>
  //   </>
// )
